import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IAddNoteInterventionRequestAction {
  data: {
    interventionId: number;
    text: string;
  };
  functions: {
    close: () => void;
    error: (err: any) => void;
  };
}

function addNoteRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<IAddNoteInterventionRequestAction>,
) {
  draft.addNote.config.isLoading = true;
}

export default addNoteRequest;
